export default __webpack_public_path__ + "static/media/ipad.b24daea8.png";